export default "__VITE_ASSET__UUO1UFdK__"